// extracted by mini-css-extract-plugin
module.exports = {"sm":"768px","md":"992px","lg":"1230px"};